<template>
    <validation-observer ref="textForm">
        <div>
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <validation-provider :rules="question.mandatory ? 'required' : ''" v-slot="{errors}">
                    <label :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}" :for="id">
                        {{ question.question_text }}
                    </label>
                    <div class="text-attribute" :class="{' col-md-9 col-xs-8 ' : isInquiry}">
                        <input type="text" :name="name"
                               :id="id" class="form-control new-inputs" v-model="question.value" @blur="updateText"
                        >
                        <input type="hidden" :value="id" name="questions[]">
                        <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                    </div>
                    <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
    </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import attribute from "@/modules/Services/components/attributes/Attribute.vue";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormText",
    props: {
        value: {},
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question: this.value
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        // isNumeric() {
        //     if (this.quesion.is_price_attribute) {
        //         return true
        //     }
        //     return false
        // },

        // onChange(event) {
        //     this.textValue = event.target.value
        //     this.$emit('input', event.target.value)
        //     EventBus.$emit('onCustomFieldUpdated', {
        //         attribute: this.attribtue,
        //         value: this.textValue
        //     })
        // },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.textForm) {
                    let validated = await this.$refs.textForm.validate();
                    verify(validated)
                }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        setValue(data) {
            if(data){
                this.question.value = data;
            }
        },
        updateText(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry( this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        }
    },
    mounted() {
        this.addEventListeners(),
        this.setValue(this.question.answer_text_names)

    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners();
    }
}
</script>

<style scoped>
.p-0-1{
    padding:0px 1px;
}

@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        margin-left: 15px !important;
    }

}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
        margin-left: 15px !important;
    }

}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        margin-left: 15px !important;
    }
}
</style>